import { render } from "./ArticleComponent.vue?vue&type=template&id=63b13240&scoped=true"
import script from "./ArticleComponent.vue?vue&type=script&lang=js"
export * from "./ArticleComponent.vue?vue&type=script&lang=js"

import "./ArticleComponent.vue?vue&type=style&index=0&id=63b13240&scoped=true&lang=css"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b13240"]])

export default __exports__